import * as React from 'react';
import { CasinoGameModelExt } from 'src/domains/casino/state/AppCasino.state';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { LikeAndInfo } from './like-and-info/GameLikeAndInfo';
import { OverlayWrapper, PlayButton } from './ThumbnailOverlay.style';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { useCommon } from 'src/domains/common/Common';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';

interface PropsType {
    gameModel: CasinoGameModelExt;
    showLikeAndInfo: boolean;
    handleOnMobileClick: () => void;
    handlePlayClick?: () => void;
    handleInfoClick?: () => void;
}

export const ThumbnailOverlay = observer('ThumbnailOverlay', (props: PropsType) => {
    const { gameModel, showLikeAndInfo, handleOnMobileClick, handlePlayClick, handleInfoClick } = props;
    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);
    const isMobile = breakpointsState.tablet.isBiggerOrEq === false;
    const env = EnvironmentState.get(common);
    const detectFeatures = env.modernizrDetect;
    const isTouchEventsAvailable = detectFeatures !== null && detectFeatures.touchevents === true;

    if (isMobile || isTouchEventsAvailable) {
        return (
            <OverlayWrapper
                isMobile={true}
                onClick={handleOnMobileClick}
            />
        );
    }

    return (
        <OverlayWrapper>
            <PlayButton
                onClick={handlePlayClick ?? ((): void => gameModel.startGame())}
                data-test='play-button'
            >
                <I18n
                    langKey='casino-home.slider.game.play-button'
                    defaultText='Play Now'
                />
            </PlayButton>

            {showLikeAndInfo ? (
                <LikeAndInfo
                    isFavourite={gameModel.isFavourite}
                    gameId={gameModel.id}
                    onHeartClick={gameModel.handleLikeAction}
                    onInfoClick={handleInfoClick}
                />
            ) : null}
        </OverlayWrapper>
    );
});
